<template>
  <div @click="toggleZoom" :class="{ zoomed }" @mousemove="pan" @mouseleave="zoomOut">
    <img ref="image" :alt="alt" :src="src"/>
  </div>
</template>

<script>
  export default {
    name: 'Zoom',
    methods: {
      toggleZoom: function (e) {
        const smallImage = this.$el.clientWidth > this.$refs.image.naturalWidth;
        if (!this.isTouchDevice && this.isCurrent && !e.target.closest('.sw-carousel-thumbs') && !smallImage) {
          this.zoomed = !this.zoomed;

          if (this.zoomed) {
            this.$nextTick(function () { //wait until rendering to calculate zoom position
              this.pan(e); //pass the click event
            });

          }
        }
      },
      zoomOut: function () {
        this.zoomed = false;
      },
      pan: function (e) {
        if (this.zoomed) {
          const image = this.$refs.image;
          const el = this.$el;
          const rect = el.getBoundingClientRect();
          const mousePosition = {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
          };
          const factor = 1 - image.naturalWidth / el.clientWidth;
          const imgPosition = {
            x: mousePosition.x * factor,
            y: mousePosition.y * factor
          };

          image.style.left = `${imgPosition.x}px`;
          image.style.top = `${imgPosition.y}px`;
        }
      },
      setTouch: function () {
        this.isTouchDevice = true;
      }
    },
    data: function () {
      return {
        zoomed: false,
        isTouchDevice: false
      }
    },
    computed: {
      isCurrent: function () {
        return this.currentSlide === this.index;
      }
    },
    watch: {
      isCurrent: function (val) {
        this.zoomed = val ? this.zoomed : false;
      },
      zoomed: function (val) {
        if (!val) {
          const image = this.$refs.image;
          image.style.top = 'auto';
          image.style.left = 'auto';
        }
      }
    },
    props: {
      currentSlide: {
        type: Number,
        required: true
      },
      index: {
        type: Number,
        required: true
      },
      src: {
        type: String,
        required: true
      },
      alt: {
        type: String,
        required: true
      }
    },
    mounted: function () {
      window.addEventListener('touchstart', this.setTouch);
    },
    beforeDestroy: function () {
      window.removeEventListener('touchstart', this.setTouch);
    }
  }
</script>
